import type { BrandFilter } from "@/marketing/models/brand";

export const BRAND_KEYS = {
  all: ["brands"] as const,
  lists: () => [...BRAND_KEYS.all, "list"] as const,
  list: (filter: BrandFilter) => [...BRAND_KEYS.lists(), filter] as const,
  details: () => [...BRAND_KEYS.all, "detail"] as const,
  detail: (brandId: string) => [...BRAND_KEYS.details(), brandId] as const,
};
